// Audio is unlocked by a user gesture; notification polling never prompts for permissions.
export function createLetterSound() {
  let context = null;
  return {
    async unlock() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return false;
        if (!context) context = new AudioContext();
        if (context.state === 'suspended') await context.resume();
        return context.state === 'running';
      } catch {
        return false;
      }
    },
    play() {
      if (!context || context.state !== 'running') return;
      const start = context.currentTime;
      [660, 880].forEach((frequency, index) => {
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        const time = start + index * 0.18;
        oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(0, time);
        gain.gain.linearRampToValueAtTime(0.12, time + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.001, time + 0.16);
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
        oscillator.start(time);
        oscillator.stop(time + 0.17);
      });
    },
    dispose() {
      if (context) context.close().catch(() => {});
      context = null;
    },
  };
}
